import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patotp',
  templateUrl: './patotp.component.html',
  styleUrls: ['./patotp.component.css']
})
export class PatotpComponent implements OnInit {
  ngOtpInputRef:any;
  timeLeft: number = 20;
  interval;
  showResendFlag:boolean=false
  constructor() { }

  ngOnInit(): void {
    this.startTimer();
  }
  startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      }
      else if(this.timeLeft==0){
this.showResendFlag=true
      }
       else {
        this.timeLeft = 20;
      }
    },1000)
  }

  // to pause timer code start here
  pauseTimer() {
    clearInterval(this.interval);
  }
  // to pause timer code end here
}
